import { render, staticRenderFns } from "./PersonalisationDetails.vue?vue&type=template&id=f5e1c310&scoped=true"
import script from "./PersonalisationDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalisationDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PersonalisationDetails.vue?vue&type=style&index=0&id=f5e1c310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e1c310",
  null
  
)

export default component.exports